export const eventDetailsWrap = (detailsContent, optionalClass='') => `
<div class="event-details ${optionalClass}" >    
    ${detailsContent}
</div>`;